import React from "react";

const GuideCoverHero = ({ headline, lead, cover }) => (
  <header className="guide-cover">
    <div className="guide-cover__banner">{cover.banner}</div>
    <div className="guide-cover__inner">
      <figure className="guide-cover__figure">
        <img
          src={cover.illustration}
          alt={cover.illustrationAlt}
          className="guide-cover__illus"
          width={320}
          height={208}
          loading="eager"
          decoding="async"
        />
        <div className="guide-cover__decor guide-cover__decor--tl" aria-hidden="true" />
        <div className="guide-cover__decor guide-cover__decor--br" aria-hidden="true" />
      </figure>
      <div className="guide-cover__text">
        <h1 className="guide-cover__title">{headline}</h1>
        {lead ? <p className="guide-cover__lead">{lead}</p> : null}
      </div>
    </div>
  </header>
);

export default GuideCoverHero;
